// Real company logo — bigger and cleaner. Renders the client-provided logo image.
export default function NagoLogo({ className = "h-14 sm:h-16 w-auto" }) {
  return (
    <img
      src="/images/nago/logo.png"
      alt="Nago International — Where Industrial Performance Meets Dependable Supply"
      className={`${className} object-contain`}
      loading="eager"
      decoding="async"
    />
  );
}
